module.exports = __webpack_public_path__ + "static/img/流程管理.95a47c07.png";